import { useState } from "react";
import { Card, CardContent, Container, Grid } from "@material-ui/core";
import { IsMobile } from "utils/is-mobile";
import FilterCard from "components/_refactor/filter-card";
import HeaderClientes from "components/_refactor/headers/clients";
import StructureFields from "components/_refactor/fields/structure";
import PeriodField from "components/_refactor/fields/period-field";
import BigNumberCard from "components/_refactor/card/big-number";
import TablePainelEntrega from "./components/table-painel-entrega";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import UtilsFncs from "utils/UtilsFncs";
import LoadingData from "components/Loading/LoadingData";
import MaskAndValid from "utils/maskAndValid";
import InputText from "components/_refactor/text/input";
import DialogOcorrenciasTransporte from "./components/dialog-ocorrencias-transporte";

const dataHoje = new Date().toISOString().slice(0, 10);

export default function PainelEntrega() {
  const [structureFilters, setStructureFilters] = useState({});
  const [periodo, setPeriodo] = useState("30");
  const [periodoInicial, setPeriodoInicial] = useState(dataHoje);
  const [periodoFinal, setPeriodoFinal] = useState(dataHoje);
  const [clearFilters, setClearFilters] = useState(false);
  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);

  const [ocorrenciasNF, setOcorrenciasNF] = useState(null);
  const [data, setData] = useState();
  const [cardsData, setCardsData] = useState({
    emandamento: "-",
    entregue: "-",
    ematraso: "-",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [loadingCards, setLoadingCards] = useState(false);
  const snackbar = useSnackbar();

  const [cnpj, setCnpj] = useState("");
  const isValidCnpj = cnpj ? MaskAndValid.validateCNPJ(cnpj) : false;
  const cnpjUnmasked = cnpj?.replace(/[^\d]+/g, "");

  const [notaFiscal, setNotaFiscal] = useState("");
  const [numeroPedido, setNumeroPedido] = useState("");

  const isMobile = IsMobile();
  const itemSM = isMobile ? 12 : 4;

  const handleSearchDelivery = async ({
    page = 0,
    sizePerPage = 25,
    status = "",
  }) => {
    setIsLoading(true);
    try {
      const queryParams =
        "?page=" +
        page +
        "&pageSize=" +
        sizePerPage +
        "&status=" +
        status +
        "&dtIni=" +
        periodoInicial +
        "&dtFim=" +
        periodoFinal +
        (notaFiscal ? `&nrNf=${notaFiscal}` : "") +
        (numeroPedido ? `&nrPedido=${numeroPedido}` : "");

      const paramsWithCnpj = {
        ...structureFilters,
        ...(isValidCnpj && { cnpj: cnpjUnmasked }),
      };

      const response = await Api.get(
        "list-order",
        "omnireport",
        UtilsFncs.RestParamsComposer(paramsWithCnpj, queryParams),
        true
      );
      setData(
        (response?.Result?.ListPedidos || []).map((item, idx) => ({
          ...item,
          IdDelivery: item.IdDelivery ?? idx,
        }))
      );
      setCurrentPage(page);
      setCurrentSizePerPage(sizePerPage);
      setTotalRegisters(response?.Result?.TotalRegistros || 0);
    } catch (error) {
      snackbar.showMessage(
        "Erro ao buscar dados de entrega: " + error.message,
        {
          severity: "error",
        }
      );
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTotalDelivery = async (status) => {
    const listStatus = [
      { status: "EMANDAMENTO", value: "TotalAdamento" },
      { status: "EMATRASO", value: "TotalAtraso" },
      { status: "ENTREGUE", value: "TotalEntrege" },
    ];
    try {
      const queryParams =
        "?status=" +
        status +
        "&dtIni=" +
        periodoInicial +
        "&dtFim=" +
        periodoFinal +
        (notaFiscal ? `&nrNf=${notaFiscal}` : "") +
        (numeroPedido ? `&nrPedido=${numeroPedido}` : "");

      const paramsWithCnpj = {
        ...structureFilters,
        ...(isValidCnpj && { cnpj: cnpjUnmasked }),
      };

      const response = await Api.get(
        "list-order-total",
        "omnireport",
        UtilsFncs.RestParamsComposer(paramsWithCnpj, queryParams),
        true
      );

      return {
        status: status.toLowerCase(),
        value:
          response.Result[listStatus.find((s) => s.status === status).value],
      };
    } catch (error) {
      snackbar.error("Erro ao buscar totais: " + error.message);
      return { status: status.toLowerCase(), value: "-" };
    }
  };

  const handleAllTotals = async () => {
    setLoadingCards(true);
    try {
      const promises = [
        handleTotalDelivery("EMANDAMENTO"),
        handleTotalDelivery("ENTREGUE"),
        handleTotalDelivery("EMATRASO"),
      ];

      const results = await Promise.all(promises);

      const newCardsData = results.reduce((acc, result) => {
        acc[result.status] = result.value;
        return acc;
      }, {});

      setCardsData(newCardsData);
    } catch (error) {
      console.error("Erro ao buscar totais:", error);
    } finally {
      setLoadingCards(false);
    }
  };

  const handleOccurencesData = async (row) => {
    try {
      const response = await Api.get(
        "tracking-occurrences",
        "sellinorder",
        "?chaveNF=" + row.ChaveNf,
        true
      );

      if (!response || response.Result?.Ocorrencias?.length === 0) {
        snackbar.showMessage(
          "Não foram encontradas ocorrências de entrega para essa nota.",
          {
            severity: "info",
          }
        );
      } else {
        setOcorrenciasNF({ ...row, ...response.Result });
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });
      console.log(error);
    }
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setPeriodo("30");
    setPeriodoInicial(dataHoje);
    setPeriodoFinal(dataHoje);
    setCnpj("");
    setNotaFiscal("");
    setNumeroPedido("");
  };

  const CARDS_INFO = [
    {
      title: "Entregas em Andamento",
      value: cardsData.emandamento,
      loading: loadingCards,
      legend: "Filtrar por entregas em andamento",
      onClick: () => {
        handleSearchDelivery({
          page: 0,
          sizePerPage: currentSizePerPage,
          status: "EMANDAMENTO",
        });
      },
    },
    {
      title: "Entregas Realizadas",
      value: cardsData.entregue,
      loading: loadingCards,
      legend: "Filtrar por entregas realizadas",
      onClick: () => {
        handleSearchDelivery({
          page: 0,
          sizePerPage: currentSizePerPage,
          status: "ENTREGUE",
        });
      },
    },
  ];

  const handleSearch = () => {
    setClearFilters(false);
    handleSearchDelivery({
      page: currentPage,
      sizePerPage: currentSizePerPage,
      status: "",
    });
    handleAllTotals();
  };

  return (
    <>
      <HeaderClientes
        section="Acompanhamento de Entrega"
        subsection="Clientes"
      />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={isLoading}
          searching={isLoading}
          handleClearFilters={handleClearFilters}
        >
          <StructureFields
            onStructureFieldsChange={setStructureFilters}
            disableAll={isLoading}
            onStructureFieldsLoad={setStructureFilters}
            requiredFields={["economicGroup"]}
            hideFields={["brand", "channel"]}
            clearFilters={clearFilters}
            handleSearch={handleSearch}
          />
          <Grid item xs={12} sm={4} md={4}>
            <InputText
              label="CNPJ"
              value={cnpj}
              onChange={(e) => {
                setCnpj(MaskAndValid.maskCNPJ(e.target.value));
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              disabled={isLoading}
              placeholder="00.000.000/0000-00"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <InputText
              label="Nota Fiscal"
              value={notaFiscal}
              onChange={(e) => {
                setNotaFiscal(e.target.value);
              }}
              disabled={isLoading}
              type="number"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <InputText
              label="Número do Pedido"
              value={numeroPedido}
              onChange={(e) => {
                setNumeroPedido(e.target.value);
              }}
              disabled={isLoading}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <PeriodField
              label="Período"
              value={{ value: periodo, label: `Últimos ${periodo} dias` }}
              onChange={(option) => setPeriodo(option.value)}
              initialDate={periodoInicial}
              finalDate={periodoFinal}
              setInitialDate={setPeriodoInicial}
              setFinalDate={setPeriodoFinal}
              disabled={isLoading}
              required={false}
            />
          </Grid>
        </FilterCard>

        <Card>
          <CardContent>
            <Grid container spacing={2}>
              {CARDS_INFO.map((card, index) => (
                <Grid item xs={itemSM} key={index}>
                  <BigNumberCard
                    title={card.title}
                    value={card.value}
                    loading={card.loading}
                    legend={card.legend}
                    onClick={card.onClick}
                  />
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>

        <Grid item xs={12}>
          {isLoading ? (
            <LoadingData searching={isLoading} label="Buscando dados..." />
          ) : (
            <TablePainelEntrega
              data={data}
              totalRegistros={totalRegisters}
              currentPage={currentPage}
              currentSizePerPage={currentSizePerPage}
              handleSelectRow={handleOccurencesData}
              onTableChange={(type, { page, sizePerPage }) => {
                handleSearchDelivery({ page: page - 1, sizePerPage });
              }}
            />
          )}
        </Grid>
      </Container>

      {ocorrenciasNF && (
        <DialogOcorrenciasTransporte
          open={!!ocorrenciasNF}
          onClose={() => setOcorrenciasNF(null)}
          chaveNf={ocorrenciasNF?.ChaveNf}
          numero={ocorrenciasNF?.Numero}
          serie={ocorrenciasNF?.Serie}
        />
      )}
    </>
  );
}
